export default __webpack_public_path__ + "static/building-xs-0324d90c4893984946716c129d8c4b41.webp";